import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/feature-app-screenshot.webp")